import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, TablePagination, Typography
} from '@mui/material';
import dayjs from 'dayjs';

const TransactionFeeTable = ({ logs }) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginatedLogs = logs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <Typography variant="h6" gutterBottom>
      Journal des modifications des frais
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Ancien %</TableCell>
              <TableCell>Nouveau %</TableCell>
              <TableCell>Modifié par</TableCell>
              <TableCell>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedLogs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>No logs found.</TableCell>
              </TableRow>
            ) : (
              paginatedLogs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{log.old_percentage}%</TableCell>
                  <TableCell>{log.new_percentage}%</TableCell>
                  <TableCell>
                    {log.changed_by || `User ${log.changed_by_user_id || 'N/A'}`}
                  </TableCell>
                  <TableCell>
                    {dayjs(log.changed_at).format('YYYY-MM-DD HH:mm')}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={logs.length}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10]}
        onPageChange={handleChangePage}
      />
    </>
  );
};

export default TransactionFeeTable;
